import * as React from 'react';

const AircraftIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="482"
      height="205"
      viewBox="0 0 482 205"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="aircraft-illustration"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M187.531 205H294.923C297.96 205 300.431 202.527 300.431 199.488V5.51197C300.431 2.47284 297.96 0 294.923 0H187.531C184.494 0 182.024 2.47284 182.024 5.51197V199.488C182.024 202.527 184.494 205 187.531 205ZM182.943 47.5186V199.488V47.5186ZM182.943 199.488C182.943 202.024 184.997 204.08 187.531 204.08L182.943 199.488ZM187.531 204.08H294.923H187.531ZM294.923 204.08C297.457 204.08 299.511 202.024 299.511 199.488L294.923 204.08ZM299.511 199.488V5.51197V199.488ZM299.511 5.51197C299.511 2.97614 297.457 0.920457 294.923 0.920457L299.511 5.51197ZM294.923 0.920457L229.506 0.920461L294.923 0.920457Z"
        fill="#E6E8E9"
      />
      <path
        d="M299.874 51.1187C299.874 51.4473 300.242 51.7111 300.7 51.7111H442.586C443.044 51.7111 443.413 51.4473 443.413 51.1187C443.413 50.7902 443.044 50.5264 442.586 50.5264H300.7C300.242 50.5264 299.874 50.7902 299.874 51.1187H299.874Z"
        fill="#E6E8E9"
      />
      <path
        d="M184.48 135.712L185.884 172.952H182.466V177.168H192.019V172.952H189.233L189.432 135.712H184.48Z"
        fill="#31383C"
      />
      <path
        d="M180.794 166.98H180.794C182.248 166.98 183.427 168.16 183.427 169.615V180.506C183.427 181.962 182.248 183.141 180.794 183.141H180.794C179.34 183.141 178.161 181.962 178.161 180.506V169.615C178.161 168.16 179.34 166.98 180.794 166.98Z"
        fill="#31383C"
      />
      <path
        d="M194.134 166.98H194.134C195.588 166.98 196.767 168.16 196.767 169.615V180.506C196.767 181.962 195.588 183.141 194.134 183.141H194.134C192.68 183.141 191.501 181.962 191.501 180.506V169.615C191.501 168.16 192.68 166.98 194.134 166.98Z"
        fill="#3F3D56"
      />
      <path
        d="M215.548 112.509L161.486 110.05L169.911 106.186L217.304 106.888L215.548 112.509Z"
        fill="#2969F2"
      />
      <path
        d="M0 117.97L6.52909 115.511L209.229 120.781L217.655 116.916L214.144 140.806L53.1304 123.636L0 117.97Z"
        fill="#2969F2"
      />
      <path
        d="M52.1318 131.847L53.1304 123.636L214.144 140.806L213.267 152.927L52.1318 131.847Z"
        fill="#31383C"
      />
      <ellipse
        cx="160.433"
        cy="138.347"
        rx="16.6752"
        ry="17.7419"
        fill="#31383C"
      />
      <ellipse
        cx="160.433"
        cy="135.185"
        rx="12.287"
        ry="12.2963"
        fill="#2969F2"
      />
      <path
        d="M297.52 135.712L296.116 172.952H299.534V177.168H289.981V172.952H292.767L292.568 135.712H297.52Z"
        fill="#31383C"
      />
      <rect
        x="298.573"
        y="166.98"
        width="5.26585"
        height="16.1609"
        rx="2.63293"
        fill="#31383C"
      />
      <rect
        x="285.233"
        y="166.98"
        width="5.26585"
        height="16.1609"
        rx="2.63293"
        fill="#31383C"
      />
      <path
        d="M266.452 112.509L320.514 110.05L312.089 106.186L264.696 106.888L266.452 112.509Z"
        fill="#2969F2"
      />
      <path
        d="M247.101 104.94L244.644 50.8359L240.782 59.2677L241.484 106.696L247.101 104.94Z"
        fill="#2969F2"
      />
      <path
        d="M482 117.97L475.471 115.511L272.771 120.781L264.345 116.916L267.856 140.806L428.87 123.636L482 117.97Z"
        fill="#2969F2"
      />
      <path
        d="M429.868 131.847L428.87 123.636L267.856 140.806L268.733 152.927L429.868 131.847Z"
        fill="#31383C"
      />
      <ellipse
        cx="321.567"
        cy="138.347"
        rx="16.6752"
        ry="17.7419"
        fill="#31383C"
      />
      <ellipse
        cx="321.567"
        cy="135.185"
        rx="12.287"
        ry="12.2963"
        fill="#2969F2"
      />
      <path
        d="M271.63 105.77L270.833 111.647L270.418 143.28C270.387 145.634 270.102 147.96 269.569 150.215C268.031 156.785 264.44 162.761 259.135 167.093C254.323 171.028 247.758 174.007 239.069 173.48C215.899 172.075 213.853 152.341 213.853 152.341L214.727 116.555L214.846 111.647L215.899 102.791C215.899 102.791 218.708 77.8471 244.686 78.5497C270.664 79.2524 271.63 105.77 271.63 105.77H271.63Z"
        fill="#2969F2"
      />
      <path
        d="M221.516 97.5212L226.782 89.0894L233.452 86.9814H256.271L261.888 89.0894L266.985 97.5212L257.675 93.3053H231.559L221.516 97.5212Z"
        fill="#E6E8E9"
      />
      <path
        d="M240.827 158.14L241.728 182.03H239.535V184.734H245.664V182.03H243.876L244.004 158.14H240.827Z"
        fill="#31383C"
      />
      <path
        d="M238.463 178.198C239.395 178.198 240.152 178.955 240.152 179.889V186.875C240.152 187.809 239.395 188.566 238.463 188.566C237.53 188.566 236.774 187.809 236.774 186.875V179.889C236.774 178.955 237.53 178.198 238.463 178.198Z"
        fill="#31383C"
      />
      <path
        d="M247.02 178.198C247.953 178.198 248.71 178.955 248.71 179.889V186.875C248.71 187.809 247.953 188.566 247.02 188.566C246.088 188.566 245.331 187.809 245.331 186.875V179.889C245.331 178.955 246.088 178.198 247.02 178.198Z"
        fill="#31383C"
      />
      <path
        d="M229.442 99.2777L234.292 81.8028L235.227 82.0626L230.377 99.5375L229.442 99.2777Z"
        fill="#2969F2"
      />
      <path
        d="M255.334 84.7783L256.286 84.591L259.78 102.387L258.828 102.574L255.334 84.7783Z"
        fill="#2969F2"
      />
      <ellipse
        cx="356.222"
        cy="50.3631"
        rx="6.30553"
        ry="6.31035"
        fill="#2969F2"
      />
      <ellipse
        cx="181.697"
        cy="71.0184"
        rx="6.30553"
        ry="6.31035"
        fill="#2969F2"
      />
      <path
        d="M38.9216 189.461C38.9216 189.789 39.2898 190.053 39.7482 190.053H181.634C182.092 190.053 182.46 189.789 182.46 189.461C182.46 189.132 182.092 188.868 181.634 188.868H39.7482C39.2898 188.868 38.9216 189.132 38.9216 189.461Z"
        fill="#E6E8E9"
      />
      <ellipse
        cx="95.27"
        cy="188.706"
        rx="6.30553"
        ry="6.31035"
        fill="#2969F2"
      />
    </svg>
  );
});

AircraftIllustration.displayName = 'AircraftIllustration';

export { AircraftIllustration };
